interface IConvertionOptions {
  [key: string]: string
}

export const convertRichTextToDesiredStyling = (
  richText: string,
  options: IConvertionOptions[]
) => {
  if (options.length < 1) {
    return richText
  }

  let tmpString = richText
  options.forEach((option) => {
    const key = Object.keys(option)[0]
    const value = option[key]

    tmpString = tmpString.replaceAll(key, value)
  })

  return tmpString
}
